import { Fragment, useState } from 'react'

import Burgermenu from '@/assets/burgerMenu.svg?react'
import { LottieSpinner } from '@/components/LottieSpinner/LottieSpinner'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { weCheckPalette } from '@/utils/palette/weCheckPalette'

export type BurgerMenuActionItem = {
  kind: 'action'
  label: string
  onClick: () => void
  isLoading?: boolean
  disabled?: boolean
}

export type BurgerMenuCustomItem = {
  kind: 'custom'
  render: (close: () => void) => React.ReactNode
}

export type BurgerMenuItem = BurgerMenuActionItem | BurgerMenuCustomItem

interface BurgerMenuProps {
  items: BurgerMenuItem[]
  headerTitle?: string
  showLoadingOverlay?: boolean
  loadingOverlayText?: string
}

export const BurgerMenu = ({
  items,
  headerTitle,
  showLoadingOverlay = false,
  loadingOverlayText,
}: BurgerMenuProps) => {
  const [open, setOpen] = useState(false)
  const close = () => setOpen(false)

  if (items.length === 0) return null

  return (
    <>
      {showLoadingOverlay && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <LottieSpinner text={loadingOverlayText} />
        </div>
      )}

      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button className="flex items-center justify-center" variant="ghost">
            <Burgermenu color={weCheckPalette.neutralColor} />
          </Button>
        </PopoverTrigger>

        <PopoverContent
          align="end"
          collisionPadding={8}
          className="w-52 p-0 border-2 border-baseColorHighlight bg-baseColor rounded-md"
        >
          <div className="flex flex-col justify-start items-start">
            {headerTitle && (
              <p className="w-full pl-2 py-2 border-b-2 border-baseColorHighlight">
                {headerTitle}
              </p>
            )}
            {items.map((item, i) => {
              if (item.kind === 'custom') {
                return (
                  <div key={i} className="w-full">
                    {item.render(close)}
                  </div>
                )
              }
              return (
                <Fragment key={i}>
                  <Button
                    variant="ghost"
                    isLoading={item.isLoading}
                    disabled={item.disabled}
                    onClick={() => {
                      item.onClick()
                      close()
                    }}
                    className="w-full rounded-none pl-2 justify-start cursor-pointer"
                  >
                    {item.label}
                  </Button>
                </Fragment>
              )
            })}
          </div>
        </PopoverContent>
      </Popover>
    </>
  )
}
